import React, { useState } from 'react';
import { useHedera } from '../../contexts/HederaContext';
import './WalletButton.css';


function WalletButton() {
    const { accountId, isConnecting, error, isInitialized, connect, disconnect } = useHedera();
    const [isHovering, setIsHovering] = useState(false);

    const handleClick = async () => {
        if (!isInitialized) {
            console.error('SDK not initialized yet');
            return;
        }

        if (accountId) {
            await disconnect();
        } else {
            try {
                await connect();
            } catch (err) {
                console.error('Connection failed:', err);
            }
        }
    };

    const formatAccountId = (id) => {
        if (!id) return '';
        if (id.length <= 8) return id;
        return `${id.slice(0, 4)}...${id.slice(-4)}`;
    };

    if (!isInitialized) {
        return (
            <button 
                className="wallet-button initializing"
                disabled={true}
            >
                INITIALIZING
            </button>
        );
    }

    return (
        <div className="wallet-module-container">
            {accountId && (
                <div className="token-icon-container">
                    <img 
                        src={`${process.env.PUBLIC_URL}/static/media/market_token_icon.png`} 
                        alt="Access Token" 
                        className="token-icon" 
                        title="Access Token" 
                    />
                </div>
            )}
            <button 
                className={`wallet-button ${accountId ? 'connected' : ''} ${isConnecting ? 'connecting' : ''} ${error ? 'error' : ''} ${accountId && isHovering ? 'hovering' : ''}`}
                onClick={handleClick}
                disabled={isConnecting}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
            >
                {isConnecting ? (
                    <span className="connecting-text">CONNECTING</span>
                ) : error ? (
                    <span className="error-text">CONNECTION ERROR</span>
                ) : accountId ? (
                    isHovering ? (
                        <span className="disconnect-text">DISCONNECT</span>
                    ) : (
                        <span className="account-id">{formatAccountId(accountId)}</span>
                    )
                ) : (
                    'CONNECT WALLET'
                )}
            </button>
        </div>
    );
}

export default WalletButton;